import _ = require('underscore');
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IDataAccelerationActions } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { Messages } from '../../codegen/Localize';
import { dataAccelerationForContents, DataAccelerationType } from '../actions/DataAccelerationEntityActions';
import { isAccelerationOnSiteAllowedForOwners } from '../selectors/AccelerationSelectors';

/*
 * This action redirect to the turn on acceleration button from workbook page to switch the acceleration on
 */
export const AllowAccelerationRecommendationAction: IEntityAction<IContentInfo, IDataAccelerationActions> = {
  name: EntityActionNames.DataAccelerationOn,
  translateName: Messages.accelerateView,
  isVisible: () => FeatureFlags.viewAccelerationRecommendationEngineEnabled,
  isClickable: isClickable,
  createReduxAction: (targetItems: IContentInfo[]) => dataAccelerationForContents(targetItems, DataAccelerationType.turnOnAcceleration)
};

function isClickable(availableActions: IDataAccelerationActions,
  tasks: IContentInfo[],
  state: AppState): boolean {
  return FeatureFlags.viewAccelerationRecommendationEngineEnabled
          && (isAccelerationOnSiteAllowedForOwners(state) || currentUserIsAdmin(state));
}